import * as CSS from 'csstype';



export const containerStyles: CSS.Properties = { 
    border: '.1rem solid darkgrey',
    boxShadow: '0 8px 8px -4px #45CB',
    width: '20rem',
    margin: '0 auto',
    borderRadius: '.4rem',
    height: '20rem',
    padding: '2rem',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
}

export const headerStyles: CSS.Properties = { 
    textAlign: 'center',
    color: '#6A7FDB',
    fontWeight: 'bold'
}
